module.exports = __webpack_public_path__ + "media/packs/images/flags/ME-7da84797c18b048231537f130d935f38.png";